import { FC } from 'react';
import { textBlurStyles } from '@whitesharx/starfall-frontend-core';
import { ClubsSkeleton, GameModeControllerSkeleton } from '@whitesharx/starfall-frontend-core/clubs_screen';
import { PlayButton } from '@whitesharx/starfall-frontend-ui-kit';
import { buttonsContainerStyles } from '~/styles/pages/clubs.css';
import { UserInfoSkeleton } from '~/src/components/UserInfo/UserInfoSkeleton';
import { PageLayoutSkeleton } from '~/src/components/PageLayout/PageLayoutSkeleton';
import { InfoHeaderSkeleton } from '~/src/components/InfoHeader/InfoHeaderSkeleton';

const ClubsSkeletonPage: FC = () => (
  <PageLayoutSkeleton
    rightContainer={
      <>
        <UserInfoSkeleton />

        <div className={buttonsContainerStyles}>
          <GameModeControllerSkeleton />
          <PlayButton price="-" onClick={() => {}} disabled contentClassName={textBlurStyles} />
        </div>
      </>
    }
  >
    <InfoHeaderSkeleton />

    <ClubsSkeleton />
  </PageLayoutSkeleton>
);

export default ClubsSkeletonPage;
